import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import {
  ImageCrops,
  ImageRatios,
  ImageWidths,
} from '@components/ResponsiveImageV2/types'
import { FunctionComponent } from 'react'

interface TeaserImageProps {
  src: string
  alt: string
  availableCrops?: ImageCrops
}

const imageRatios: ImageRatios = {
  desktop: '1_1',
  tablet: '1_1',
  mobile: '1_1',
}

const imageWidths: ImageWidths = {
  desktop: 85,
  tablet: 85,
  mobile: 85,
  mobileSmall: 85,
}

const TeaserImage: FunctionComponent<TeaserImageProps> = ({
  src,
  alt,
  availableCrops,
}) => (
  <ResponsiveImageV2
    src={src}
    alt={alt}
    ratios={imageRatios}
    crops={availableCrops ?? {}}
    widths={imageWidths}
  />
)

export default TeaserImage
